import React from "react";
import "./Services.css";

function Services() {
  const services = [
    {
      icon: "🚀",
      title: "Technology Solutions",
      description:
        "Cutting-edge AI, ML, and cloud services that drive digital transformation",
      link: "#ai-services",
    },
    {
      icon: "💼",
      title: "Consulting Services",
      description:
        "Strategic consulting in logistics and medical supply chain management",
      link: "#consulting",
    },
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-title">
          <h2>Our Core Services</h2>
          <p>
            Comprehensive solutions tailored to elevate your business to new
            heights
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <a href={service.link} className="service-link">
                Explore More →
              </a>
            </div>
          ))}
        </div>

        <div className="services-stats">
          <div className="stat">
            <h3>50+</h3>
            <p>Projects Delivered</p>
          </div>
          <div className="stat">
            <h3>95%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="stat">
            <h3>24/7</h3>
            <p>Support Available</p>
          </div>
          <div className="stat">
            <h3>10+</h3>
            <p>Industry Expertise</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
